import { Grid2 as Grid, Typography } from '@mui/material';
import { defaultsDeep } from 'lodash';
import { ACCEPTANCE_POLICY_LINK } from '../../constants';
import { getAnchorRowStyle, LinkField } from 'framework/ui/field';
import { EditableListDataGridLayout, EDITABLE_LIST_FIELD } from 'framework/list';
import { ProjectSectionAccordion } from 'domain/shared/newProject';

const AcceptancePoliciesList = () => (
  <ProjectSectionAccordion
    defaultExpanded
    title={
      <Grid container direction="row" justifyContent="space-between" alignItems="center" width="100%" pl={2}>
        <Grid size={8}>
          <Typography variant="h4" color="primary">
            Policies and guides
          </Typography>
        </Grid>
        <Grid size="auto" alignItems="center" sx={{ '.filter-item-wrapper': { m: 0 } }} />
      </Grid>
    }
  >
    <EditableListDataGridLayout
      rowProps={data =>
        defaultsDeep(getAnchorRowStyle(data, ''), {
          sx: {
            alignItems: 'center',
            height: '40px',
          },
        })
      }
      getTableCells={async () =>
        Promise.resolve([
          {
            type: EDITABLE_LIST_FIELD,
            source: 'name',
            isEditor: false,
            component: LinkField,
            componentProps: {
              label: '',
              value: ACCEPTANCE_POLICY_LINK,
              linkText: 'Acceptance policy',
              sx: { color: 'text.secondary' },
            },
            gridCellProps: { size: 11.5, marginLeft: '40px' },
          },
        ])
      }
    />
  </ProjectSectionAccordion>
);

export default AcceptancePoliciesList;
